import { useL10n } from "@ews/react-localization-context";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsDateInput from "../../../Settings/SettingsComponents/SettingsDateInput/SettingsDateInput";

const Dates: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>
        <SettingsDateInput
            text={t("[REACT_DATE_OF_FIRST_DECISON]")}
            tooltip={<TooltipIcon text={t("[REACT_DATE_OF_FIRST_DECISON]")} />}
            inputType="date"
            value={specification.projectMilestones?.initialApprovalDate}
            onBlur={({ value }) =>
            {
                const date = value.toISOString();
                if (specification.projectMilestones?.initialApprovalDate === date) return;
                if (systemId && specification.projectMilestones) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        projectMilestones: {
                            ...specification.projectMilestones,
                            initialApprovalDate: date
                        },
                    });
                }
            }
            } />
        <SettingsDateInput
            text={t("TRVB_PLANNING_NOTICES_DATE_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_PLANNING_NOTICES_DATE_LABEL")} />}
            inputType="date"
            value={specification.projectMilestones?.planningStartApprox}
            onBlur={({ value }) =>
            {
                const date = value.toISOString();
                if (specification.projectMilestones?.planningStartApprox === date) return;
                if (systemId && specification.projectMilestones) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        projectMilestones: {
                            ...specification.projectMilestones,
                            planningStartApprox: date
                        },
                    });
                }
            }}
        />
        <SettingsDateInput
            text={t("TRVB_ASSEMBLY_START_DATE_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_ASSEMBLY_START_DATE_LABEL")} />}
            inputType="date"
            value={specification.projectMilestones?.installationStartApprox}
            onBlur={({ value }) =>
            {
                const date = value.toISOString();
                if (specification.projectMilestones?.installationStartApprox === date) return;
                if (systemId && specification.projectMilestones) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        projectMilestones: {
                            ...specification.projectMilestones,
                            installationStartApprox: date
                        },
                    });
                }
            }}
        />
        <SettingsDateInput
            text={t("[REACT_COMMISSIONING_APPROX.]")}
            tooltip={<TooltipIcon text={t("[REACT_COMMISSIONING_APPROX.]")} />}
            inputType="date"
            value={specification.projectMilestones?.commissioningApprox}
            onBlur={({ value }) =>
            {
                const date = value.toISOString();
                if (specification.projectMilestones?.commissioningApprox === date) return;
                if (systemId && specification.projectMilestones) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        projectMilestones: {
                            ...specification.projectMilestones,
                            commissioningApprox: date
                        },
                    });
                }
            }}
        />
    </>;
};

export default Dates;
